import { j as s } from "./jsx-runtime-3tyXYecC.mjs";
import { useMemo as z, useRef as N, useImperativeHandle as q } from "react";
import { f as C } from "./index-LyFokDcn.mjs";
import { m as L } from "./tss-DN0acMKN.mjs";
import { M as c, d as h } from "./constants-CnFYFetN.mjs";
import { B as H } from "./base-icon-v2-DZwX3wnO.mjs";
import { S as I } from "./screen-reader-only-text-B-XgpPEP.mjs";
import { _ as W } from "./composeRefs-YONvD-rx.mjs";
import { S as F } from "./status-message-BMoS1d1Y.mjs";
import { L as A } from "./layout-box-DFBM-kSI.mjs";
import { m as O } from "./index-BGgjYpYz.mjs";
import { g as _ } from "./get-aria-describedby-G1wcWKF2.mjs";
const E = (u, e) => {
  let i = e(2.5), p = e(5), r = e(2), n = e(2), o = e(0.25), t = e(2.75), b = e(0.25), f = "5px", a = e(0.75), l = e(3);
  return u === "large" ? (i = e(4), p = e(6.75), r = e(3), n = e(3), o = e(0.5), t = e(3.25), b = e(0.5), f = "9px", a = e(1), l = e(4)) : u === "small" && (i = e(2), p = e(4), r = e(1.5), n = e(1.5), o = e(0.25), t = e(2.25), b = e(0.25), f = e(0.5), a = e(0.5), l = e(2.5)), {
    inputBeforeRight: b,
    inputNestedLeft: a,
    labelBeforeHeight: r,
    labelBeforeRight: t,
    labelBeforeTop: o,
    labelBeforeWidth: n,
    labelHeight: i,
    labelWidth: p,
    valueLeft: l,
    valueTop: f
  };
}, U = L()((u, e, i) => {
  const { size: p } = e, { constructs: r, mixins: n, mode: o, palette: t, typography: b, spacing: f } = u, a = "200ms", l = "cubic-bezier(0.25, 0.1, 0.25, 1)", {
    inputBeforeRight: $,
    inputNestedLeft: R,
    labelBeforeHeight: w,
    labelBeforeRight: x,
    labelBeforeTop: d,
    labelBeforeWidth: g,
    labelHeight: m,
    labelWidth: v,
    valueLeft: k,
    valueTop: y
  } = E(p, f);
  return C.ifFeature(
    "encore",
    {
      toggle: {
        boxSizing: "border-box",
        cursor: "pointer",
        display: "inline-flex",
        outline: o === c.Dye ? `2px solid ${h.main}` : void 0,
        position: "relative",
        userSelect: "none",
        ":has(> input:disabled)": {
          cursor: "default"
        }
      },
      value: {
        left: k,
        position: "absolute",
        display: "flex",
        top: y,
        transition: `left ${a} ${l}`
      },
      input: {
        height: "1px",
        opacity: 0,
        position: "absolute",
        width: "1px",
        [`&:checked ~ .${i.label}`]: {
          backgroundColor: o === c.Dye ? h.main : t.primary.main,
          boxShadow: `1px 1px 0px 1px ${n.alpha(r.surface.neutral.xxStrong, 0.1)} inset`,
          "&:before": {
            right: $
          },
          [`& > .${i.value}`]: {
            border: "none",
            left: R,
            opacity: 1
          }
        },
        [`&:focus ~ .${i.label}`]: {
          boxShadow: `0 0 0 2px ${r.surface.primary.medium}, 0 0 0 4px ${r.surface.primary.weak}, inset 1px 2px 0px -1px ${n.alpha(t.common.black, 0.1)}`
        }
      },
      label: {
        backgroundColor: o === c.Dye ? h.lighter : t.gray[400],
        border: "none",
        borderRadius: u.borderRadiuses[1e3],
        boxShadow: `1px 1px 0px 1px ${n.alpha(r.surface.neutral.xxStrong, 0.03)}`,
        height: m,
        width: v,
        // circle handle
        "&:before": {
          backgroundColor: r.icon.neutral.inverted,
          borderRadius: u.borderRadiuses[1e3],
          content: '""',
          height: w,
          right: x,
          opacity: 1,
          position: "absolute",
          top: d,
          transition: `${a} ${l}`,
          width: g
        }
      },
      icon: {
        fill: r.icon.neutral.inverted
      }
    },
    {
      toggle: {
        boxSizing: "border-box",
        cursor: "pointer",
        display: "inline-flex",
        outline: o === c.Dye ? `2px solid ${h.main}` : void 0,
        position: "relative",
        userSelect: "none",
        ":has(> input:disabled)": {
          cursor: "default"
        }
      },
      value: {
        color: t.common.white,
        fontSize: "24px",
        lineHeight: "25px",
        fontWeight: b.fontWeightBold,
        left: "18px",
        position: "absolute",
        display: "flex",
        transition: `left ${a} ${l}`
      },
      input: {
        height: "1px",
        opacity: 0,
        position: "absolute",
        width: "1px",
        [`&:checked ~ .${i.label}`]: {
          backgroundColor: o === c.Dye ? h.main : t.primary.main,
          boxShadow: "0 1px 0 0 rgba(0, 0, 0, 0.05)",
          "&:before": {
            left: "18px"
          },
          [`& > .${i.value}`]: {
            border: "none",
            left: "4px",
            opacity: 1
          }
        }
      },
      label: {
        backgroundColor: o === c.Dye ? h.lighter : t.gray[500],
        border: "none",
        borderRadius: "2px",
        height: "16px",
        width: "32px",
        // square handle
        "&:before": {
          backgroundColor: t.common.white,
          borderRadius: "2px",
          content: '""',
          height: "14px",
          left: "1px",
          opacity: 1,
          position: "absolute",
          top: "1px",
          transition: `${a} ${l}`,
          width: "13px"
        }
      },
      icon: {}
    }
  );
}), ie = (u) => {
  const {
    apiRef: e,
    ariaLabel: i,
    ariaDescribedby: p,
    containerRef: r,
    controlled: n = !1,
    errorMessage: o,
    onChange: t,
    onBlur: b,
    inputRef: f,
    isChecked: a,
    isDisabled: l,
    isRequired: $,
    name: R,
    id: w,
    size: x = "medium",
    status: d,
    warningMessage: g
  } = u, { classes: m } = U({ size: x }), v = z(() => O(), []), k = R || "fab-requiredToggle", y = w || `fab-required-Toggle--${v}`;
  let S = 10;
  x === "small" ? S = 8 : x === "large" && (S = 14);
  const B = N(null);
  q(
    e,
    () => ({
      focus: () => {
        var T;
        (T = B.current) == null || T.focus();
      }
    }),
    [B]
  );
  const j = `${y}-status-message`, D = d === "error" ? o : g, M = _(d === "error" && o || d === "warning" && g ? j : "", p);
  return /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsxs(
      "label",
      {
        className: m.toggle,
        "data-fabric-component": "RequiredToggle",
        htmlFor: y,
        ref: r,
        children: [
          /* @__PURE__ */ s.jsx(
            "input",
            {
              "aria-describedby": M,
              "aria-invalid": d === "error",
              checked: n ? a || !1 : void 0,
              className: m.input,
              defaultChecked: a || !1,
              disabled: l,
              id: y,
              name: k,
              onBlur: b,
              onChange: t,
              ref: W(B, f),
              required: $,
              role: "switch",
              type: "checkbox"
            }
          ),
          /* @__PURE__ */ s.jsx("span", { className: m.label, children: /* @__PURE__ */ s.jsx("span", { className: m.value, children: C.ifFeature(
            "encore",
            /* @__PURE__ */ s.jsx(H, { className: m.icon, height: S, name: "asterisk-solid", width: S }),
            "*"
          ) }) }),
          /* @__PURE__ */ s.jsx(I, { children: i })
        ]
      }
    ),
    (d === "error" && o || d === "warning" && g) && /* @__PURE__ */ s.jsx(A, { marginTop: 0.5, children: /* @__PURE__ */ s.jsx(F, { id: j, message: D, showIcon: !0, status: d }) })
  ] });
};
export {
  ie as R
};
//# sourceMappingURL=index-CtI1AzVP.mjs.map
